import React from 'react';
import styled, { css } from 'styled-components';
import { isEmptyArray } from '../../core/util/array';
import { colors } from '../../constants/colors';

const Root = styled.div.withConfig({ componentId: 'sc-ojar18-0' })`
  display: flex;
  justify-content: center;
  transition: 0.2s ease;
  div:last-of-type > div {
    border-radius: 0 3px 3px 0;
  }
  div:not(:first-of-type):not(:last-of-type) > div {
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
  & > div {
    display: flex;
    flex-grow: 1;
  }
`;

const Sublabel = styled.div.withConfig({ componentId: 'sc-ojar18-1' })`
  font-size: 12px;
  text-align: center;
`;

const Option = styled(({ selected, ...rest }) => <div {...rest} />).withConfig({ componentId: 'sc-ojar18-2' })`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px 8px;
  text-align: center;
  cursor: pointer;
  transition: 0.2s ease;
  width: 100%;

  ${(props) =>
    props.selected &&
    css`
      border-radius: 3px 0 0 3px;
      background-color: ${colors.crunchBerry};
      border: 1px solid ${colors.crunchBerry};
      color: ${colors.white};
    `}

  ${(props) =>
    !props.selected &&
    css`
      border: 1px solid ${colors.greyHounds};
      border-radius: 3px 0 0 3px;
      background-color: ${colors.white};
      color: ${colors.greyWorm};
    `}
`;

type Props = {
  field: any;
  id: string;
  label?: string;
  trackEvent?: string;
  options?: any[];
  className?: any;
  handleChangeOption?: (...args: any[]) => any;
  inputProps?: any;
};

const ToggleOption = (props: Props) => {
  const { options } = props;

  const handleClick = (option: any) => {
    props.field.onChange(option);

    if (typeof props.handleChangeOption === 'function') {
      props.handleChangeOption(option);
    }
  };

  const isSelected = (option: any) => (props.field.value || props.field.initialValue) === option;

  if (isEmptyArray(options)) {
    return null;
  }

  return (
    <Root>
      {options?.map(({ label, sublabel, value, styles }, i) => (
        <div key={label}>
          <Option
            id={`${props.id}-${i}`}
            onClick={() => handleClick(value)}
            selected={isSelected(value)}
            style={styles}
          >
            {label}

            {!!sublabel && <Sublabel>{sublabel}</Sublabel>}
          </Option>
        </div>
      ))}
    </Root>
  );
};

export default ToggleOption;
